import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from '../ui/FadeIn';
export function MechanismSection() {
  const steps = [{
    number: '1',
    title: 'Limpiar',
    desc: "Usamos el Aloe para 'duchar' tu sistema digestivo y prepararlo para absorber nutrientes.",
    icon: '🌿'
  }, {
    number: '2',
    title: 'Encender',
    desc: 'Té y NRG para activar el metabolismo de forma natural, sin causar taquicardia ni ansiedad.',
    icon: '🔥'
  }, {
    number: '3',
    title: 'Nutrir',
    desc: 'Fórmula 1 (Sin Gluten) para alimentar tus células en segundos con proteína de alta calidad.',
    icon: '✨'
  }];
  return <section className="bg-charcoal text-cream py-24 px-6" data-id="element-121">
      <div className="max-w-5xl mx-auto" data-id="element-122">
        <FadeIn className="text-center mb-16" data-id="element-123">
          <h2 className="text-4xl md:text-5xl font-serif text-copper mb-6" data-id="element-124">
            El Método 1-2-3 de AEduclub
          </h2>
          <p className="text-xl text-cream/80 max-w-3xl mx-auto" data-id="element-125">
            He fusionado la sabiduría de la cocina ancestral latina con la
            ciencia de la nutrición celular de Herbalife.
          </p>
        </FadeIn>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-126">
          {steps.map((step, idx) => <StaggerItem key={idx} className="bg-white/5 p-8 rounded-sm border border-copper/20 hover:border-copper/50 transition-colors" data-id="element-127">
              <div className="text-4xl mb-6" data-id="element-128">{step.icon}</div>
              <div className="flex items-baseline gap-3 mb-4" data-id="element-129">
                <span className="text-3xl font-serif text-copper font-bold" data-id="element-130">
                  {step.number}.
                </span>
                <h3 className="text-2xl font-serif text-cream" data-id="element-131">{step.title}</h3>
              </div>
              <p className="text-cream/70 leading-relaxed" data-id="element-132">{step.desc}</p>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}